import { ValidationProvider } from 'vee-validate/dist/vee-validate.full';
import Loading from 'vue-loading-overlay';
import vmodal from 'vue-js-modal';
import EvaIcons from 'vue-eva-icons';
import Toasted from 'vue-toasted';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueI18n from 'vue-i18n';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import { auth } from '@/firebase';
import en from './locale/en.json';
import es from './locale/es.json';

Vue.config.productionTip = false;
Vue.use(EvaIcons);
Vue.use(vmodal);
Vue.use(Toasted);
Vue.use(VueI18n);

const messages = {
  en,
  es,
};

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'es', // set locale
  messages, // set locale messages
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('Loading', Loading);

Vue.filter('phone', phone => phone.replace(/[^0-9]/g, '').replace(/(\d{2,3})(\d{3})(\d{4})/, '($1) $2-$3'));

// eslint-disable-next-line
let vueInstance;

auth.onAuthStateChanged(async user => {
  if (user) {
    const { uid, emailVerified } = user;
    await store.commit('changeUserAuthStatus', { auth: true, verified: emailVerified, uid });
  } else {
    await store.commit('changeUserAuthStatus', { auth: false });
  }
  vueInstance = new Vue({
    el: '#app',
    render: h => h(App),
    router,
    store,
    i18n,
  });
});

export default vueInstance;
